import { AILoader } from 'pages/products/components';
import { EnhancedCardLoadingContainer } from './styled';
import { useGradientBorderStyles } from '../../hooks/useGradientBorderStyles';

export const EnhancedCardLoading = () => {
  const { boxBorderGradientClass } = useGradientBorderStyles({
    gradient: 'enhanced',
    backgroundColor: '#fff'
  });

  // ! render
  return (
    <EnhancedCardLoadingContainer className={boxBorderGradientClass}>
      <AILoader
        showCancelButton
        messages={['Hold on, Product Enhancer is generating content..']}
      />
    </EnhancedCardLoadingContainer>
  );
};
